import { offlineDemoAvailability } from './availability';

export const OFFLINE_DEMO_STORAGE_KEY = 'pointcraft-offline-demo-runtime-v2';
export const OFFLINE_DEMO_STORAGE_PREFIX = 'pointcraft-offline-demo:';
export const OFFLINE_DEMO_BOOT_VERSION = 1;

type OfflineDemoBootFlag = {
  enabled: true;
  version: typeof OFFLINE_DEMO_BOOT_VERSION;
};

function readBootFlag(): OfflineDemoBootFlag | null {
  if (typeof window === 'undefined') return null;

  try {
    const parsed = JSON.parse(window.localStorage.getItem(OFFLINE_DEMO_STORAGE_KEY) ?? 'null');
    if (parsed?.enabled !== true || parsed?.version !== OFFLINE_DEMO_BOOT_VERSION) return null;
    return parsed as OfflineDemoBootFlag;
  } catch {
    return null;
  }
}

export function isOfflineDemoActiveAtBoot(): boolean {
  return offlineDemoAvailability.available && readBootFlag() !== null;
}

export const isOfflineDemoActive = isOfflineDemoActiveAtBoot;

export function offlineDemoStorageKey(primaryKey: string): string {
  return isOfflineDemoActiveAtBoot()
    ? `${OFFLINE_DEMO_STORAGE_PREFIX}${primaryKey}`
    : primaryKey;
}

export function activateOfflineDemo(): boolean {
  if (!offlineDemoAvailability.available || typeof window === 'undefined') return false;

  const flag: OfflineDemoBootFlag = { enabled: true, version: OFFLINE_DEMO_BOOT_VERSION };
  window.localStorage.setItem(OFFLINE_DEMO_STORAGE_KEY, JSON.stringify(flag));
  window.location.assign('/dashboard/app-hub');
  return true;
}

export function exitOfflineDemo(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(OFFLINE_DEMO_STORAGE_KEY);
  window.location.assign('/auth/v3-device-login');
}
